import moment from 'moment';
import DTO from './DTO';
import ListType from './converters/ListType';
import MetricDTO from './MetricDTO';

class CameraDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'status',
        type: Number,
        validators: [],
        labelKey: 'parking.meter.status',
      },
      {
        name: 'available_status',
        type: Number,
        validators: [],
        labelKey: 'parking.meter.available_status',
      },
      {
        name: 'zbx_address',
        type: String,
        validators: [],
        labelKey: 'parking.meter.zbx_address',
      },
      {
        name: 'zbx_location_lat',
        type: String,
        validators: [],
        labelKey: 'parking.meter.zbx_location_lat',
      },
      {
        name: 'zbx_location_lon',
        type: String,
        validators: [],
        labelKey: 'parking.meter.zbx_location_lon',
      },
      {
        name: 'host',
        type: String,
        validators: [],
        labelKey: 'cameras.host',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'cameras.name',
      },
      {
        name: 'zbx_zone',
        type: String,
        validators: [],
        labelKey: 'parking.meter.zbx_zone',
      },
      {
        name: 'external_link',
        type: String,
        validators: [],
        labelKey: 'parking.meter.external_link',
      },
      {
        name: 'type',
        type: Number,
        validators: [],
        labelKey: 'parking.meter.type',
      },
      {
        name: 'host_component_template_id',
        type: String,
        validators: [],
        labelKey: 'parking.meter.host_component_template_id',
      },
      {
        name: 'last_ping_at',
        type: moment,
        validators: [],
        labelKey: 'last_ping_at',
      },
      {
        name: 'metrics',
        type: ListType(MetricDTO),
        validators: [],
        labelKey: 'last_ping_at',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'createdAt',
      },
      {
        name: 'updated_at',
        type: moment,
        validators: [],
        labelKey: 'updatedAt',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return this;
  }
}

export default CameraDTO;
